import React, { ReactNode } from "react";
import styled from "styled-components";
import Separator from "../../atoms/Separator";
import Text from "../../atoms/Text";

interface InfoFullPageTemplateProps {
  title: string;
  children?: ReactNode;
  footer?: ReactNode;
}

const InfoFullPageTemplate = ({
  title,
  children,
  footer,
}: InfoFullPageTemplateProps) => {
  return (
    <ContainerWrapper>
      <Container>
        <Separator type="xlarge" />
        <Text type="h1" style={{ wordBreak: "break-word" }}>
          {title}
        </Text>
        {children !== undefined && (
          <>
            <Separator type="xlarge" />
            {children}
          </>
        )}
        {footer !== undefined && (
          <>
            <Separator type="xlarge" />
            {footer}
          </>
        )}
      </Container>
    </ContainerWrapper>
  );
};
const ContainerWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: 0px 25px;
`;

const Container = styled.div`
  max-width: 500px;
`;

export default InfoFullPageTemplate;
